// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  ROOT_URL: "http://138.122.109.66:2412",
  //ROOT_URL:  "http://192.168.100.201:7000",
  //ROOT_URL: "http://localhost:7000",
  APIKEY: "AIzaSyCPjLrRyKsRg_FiwxEKLV_0JfCpLABaN7Y",
  firebase:  {
    apiKey: "AIzaSyDW44Bcr5pmUdBf08fAT6MYOiXxq8u4oKo",
    authDomain: "yms-nuo.firebaseapp.com",
    databaseURL: "https://yms-nuo.firebaseio.com",
    projectId: "yms-nuo",
    storageBucket: "yms-nuo.appspot.com",
    messagingSenderId: "824351878587",
    appId: "1:824351878587:web:3723642ac33a2340d8e89e",
    measurementId: "G-WKGHGTD481"
  },
  //notificacion_server: 'http://10.122.5.152:9010/notificacion'
   notificacion_server: 'http://localhost:9010/notificacion'
};
